export default function dataLayerHelper() {
  if (window && window.dataLayer) {
    return window.dataLayer;
  }
  throw new Error('DataLayer should be call in client-side');
}

export const eventMapping = {
  view_item_list: 'searchresults',
  view_item: 'offerdetail',
  add_to_cart: 'conversionintent',
};

const FB_ADDTOCART = 'AddToCart';
const FB_VIEWCONTENT = 'ViewContent';

export function triggerAddToCart(trip) {
  dataLayerHelper().push({
    event: 'Dynamic Remarketing - Click Book or Message',
    dynamic_remarketing_trip_id: trip._id,
    fbads_event: FB_ADDTOCART,
    fbads_params: {
      content_type: 'product',
      content_ids: trip._id
    },
    gads_event: 'add_to_cart',
    gads_params: [{
      id: trip._id,
      google_business_vertical: 'custom',
    }],
    dynx_itemid: trip._id,
    dynx_pagetype: eventMapping.add_to_cart,
  });
}

export function triggerViewSingleContent(trip, event) {
  dataLayerHelper().push({
    event,
    dynamic_remarketing_trip_id: trip._id,
    fbads_event: FB_VIEWCONTENT,
    fbads_params: {
      content_type: 'product',
      content_ids: trip._id
    },
    gads_event: 'view_item',
    gads_params: [{
      id: trip._id,
      google_business_vertical: 'custom',
    }],
    dynx_itemid: trip._id,
    dynx_pagetype: eventMapping.view_item,
  });
}

export function triggerViewManyContent(tripIds, event) {
  dataLayerHelper().push({
    event,
    dynamic_remarketing_trip_ids: tripIds,
    fbads_event: FB_VIEWCONTENT,
    fbads_params: {
      content_type: 'product',
      content_ids: [...tripIds],
    },
    gads_event: 'view_item_list',
    gads_params: tripIds.map(id => ({
      id,
      google_business_vertical: 'custom',
    })),
    dynx_itemid: tripIds,
    dynx_pagetype: eventMapping.view_item_list,
  });
}
